export default "__VITE_ASSET__D1o6EWEX__"